export enum TenantModuleType {
  Teams = 'Teams',
  Credentials = 'Credentials',
  Payments = 'Payments',
  OpportunityBoard = 'OpportunityBoard',
  Automations = 'Automations',
  CredentialCustomRules = 'CredentialCustomRules',
  Portal = 'Portal'
}
